import { Submultiples } from "../../SIprefixe";
import { Unit, UnitBaseTypes } from "../../Units";

function NewtonDividedByMillimetreSquared() {
  let dividedby = "/";
  return (
    <>
      <Unit unit={UnitBaseTypes.newton} />
      {dividedby}
      <Unit unit={UnitBaseTypes.metre} prefix={Submultiples.milli} exponent={2} />
    </>
  );
}

export default NewtonDividedByMillimetreSquared;
